import React, { useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { FiPlusSquare } from 'react-icons/fi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { IoFilterSharp } from "react-icons/io5";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import ModalEdit from '../../modals/ModelEdit/ModelEdit';
import Addproducts from '../../modals/TrendingProduct/Addproduct'
import AddProducts from '../../modals/TrendingProduct/Addproduct';


const Addprouducts = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);
   const [isModalOpen, setIsModalOpen] = useState(false);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };



  const products = [
    {
      id: 1,
      title: "Brand New Fiber Helmet",
      image: "/helmet1.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 1100,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 2,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 3,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 4,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 5,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 6,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 7,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },
    {
      id: 8,
      title: "Brand New Fiber Helmet",
      image: "/helmet2.png",
      description: "Electronics is the study and use of electrical components like .....",
      price: 2000,
      oldPrice: 3000,
      verified: true,
    },

  ];

  return (
    <div className="space-y-4 w-full">
      {/* Dropdown Section */}
      <div className="w-full">
        {/* Header */}
        <div className={`flex items-center gap-2 p-2 text-xl border-gray-500 ${openDropdown === 'one' ? '' : 'border-b'}`}>
      {/* Tooltip-enabled icon */}
      <span
        data-tooltip-id="bannerProductsTooltip"
        data-tooltip-html={`
          <div class='tooltip-bubble'>
            <div class='tooltip-content'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
              Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
            </div>
            <div class='tooltip-tail'></div>
          </div>
        `}
        className="mt-1 cursor-pointer text-gray-700"
      >
        <HiOutlineInformationCircle />
      </span>

      <h1 className='text-gray-700'>Add Products</h1>
       <div>
        <FiPlusSquare
        className="text-blue-600 cursor-pointer text-2xl "
        onClick={() => setIsModalOpen(true)}
      />

      {isModalOpen && <AddProducts closeModal={() => setIsModalOpen(false)} />}
    
    </div>
      <div
        className="cursor-pointer"
        onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
      >
        {openDropdown === 'one' ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </div>

      {/* Tooltip instance */}
      <Tooltip
        id="bannerProductsTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 !rounded-none ms-28"
      />
    </div>

        {/* Dropdown Content */}
        <div
          className={`transition-all duration-500 overflow-hidden text-sm w-full ${openDropdown === 'one' ? 'min-h-min rounded-t-md max-h-screen' : 'max-h-0 border-0 rounded-none'
            }`}
        >
          <div className="w-full h-screen overflow-y-auto">

           <div className="relative flex justify-end">
      <div
        className="flex bg-gray-200 w-fit gap-1 justify-end cursor-pointer select-none"
        onClick={() => setOpen((prev) => !prev)}
      >
        <h1 className="mt-1">
          <IoFilterSharp />
        </h1>
        <h1>Newly Added on Top</h1>
      </div>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute right-0 mt-8 bg-white border rounded shadow-lg w-48 z-50">
          <ul>
            <li className="p-2 hover:bg-gray-200 cursor-pointer">Newley added on Top</li>
            <li className="p-2 hover:bg-gray-200 cursor-pointer">Oldest on Top</li>
            <li className="p-2 hover:bg-gray-200 cursor-pointer">Verified Products</li>
            <li className="p-2 hover:bg-gray-200 cursor-pointer">Non -Verified Products</li>
            
          </ul>
        </div>
      )}
    </div>


            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4">
              
              {products?.length > 0 ? (
                products.map((product) => (
                  <div
                    key={product.id}
                    className="relative group bg-white rounded-lg shadow-md w-44 h-60 p-3 pt-0 flex-shrink-0 flex flex-col justify-between"
                  >
                    {/* 🔲 Hover Overlay with Checkbox and Edit */}
                    <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-40 rounded-lg flex justify-between items-start p-2">
                      {/* Left Checkbox */}
                      <div className="flex items-center text-white text-xs">
                        <input
                          id="default-checkbox"
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => setChecked(e.target.checked)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label htmlFor="default-checkbox" className="ml-1">
                          {checked ? "Checked" : "Unchecked"}
                        </label>
                      </div>

                    </div>

                    <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-40 rounded-lg flex justify-center items-center p-2">
                      <button
                      onClick={openModal}
                       className="text-white text-xs bg-blue-600 px-2 py-1 rounded">
                        
                        Edit
                      </button>
                       <ModalEdit isOpen={isModalOpen} onClose={closeModal} />
                    </div>

                    {/* 🖼️ Image + Badge */}
                    <div className="relative h-28 flex justify-center items-center z-10">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="h-full object-contain z-30"
                      />
                      <span className="absolute top-0 right-0 bg-blue-500 text-white text-xs px-2 py-0.5 rounded-bl-lg z-20">
                        Up to 30% off
                      </span>
                    </div>

                    {/* 🏷️ Title */}
                    <h3 className="font-semibold text-sm mt-1 leading-tight line-clamp-1 z-10">
                      {product.title}
                    </h3>

                    {/* 📄 Description */}
                    <p className="text-xs text-gray-500 leading-tight line-clamp-2 z-10">
                      {product.description}
                    </p>

                    {/* 🧑‍💼 Seller Info */}
                    <div className="flex items-center text-xs mt-1 gap-1 z-10">
                      <span>Sanjai</span>
                      <span>🇮🇳</span>
                      {product.verified && (
                        <span className="text-blue-600 font-bold">Verified ✅</span>
                      )}
                    </div>

                    {/* 💰 Price */}
                    <div className="mt-1 text-sm z-10">
                      <span className="text-black font-bold">₹ {product.price} INR</span>
                      <span className="line-through text-gray-400 text-xs ml-2">
                        ₹ {product.oldPrice}
                      </span>
                    </div>

                    {/* 🛒 Buttons */}
                    <div className="flex justify-between mt-1 z-10">
                      <button className="bg-red-500 text-white text-xs px-3 py-1 rounded">
                        Get Quotes
                      </button>
                      <button className="border text-xs px-3 py-1 rounded">
                        Contact
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p className="p-4 text-center text-gray-500">No products found</p>
              )}


            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Addprouducts;
